<script lang="ts">const { colorMode = undefined, as = 'label', disabled = false, hideLabel = false, text = '', class: className = '', ...rest } = $props();
export {};
</script>

<svelte:element
  this={as}
  {...rest}
  class="FieldLabel {className}"
  class:FieldLabel--disabled={disabled}
  data-color-mode={colorMode}
  {...hideLabel && { 'data-hide-label': 'true' }}
>
  {text}
</svelte:element>

<style>@layer design-system-components.pwds {
  .FieldLabel {
    --color: var(--color-text);
    display: block;
    width: fit-content;
    margin-bottom: var(--space-10);
    font-weight: var(--text-font-weight-medium);
  }
  .FieldLabel--disabled {
    opacity: var(--color-form-field-disabled-opacity);
  }
  .FieldLabel[data-hide-label=true] {
    position: absolute;
    overflow: hidden;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    white-space: nowrap;
    clip: rect(0 0 0 0);
  }
}</style>
